import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import FinalcialResources from './FinalcialResources';

export default function FinalAmountForIntakeTabs() {
    const [programmesData, setProgrammesData] = useState([]);
    const [loading, setLoading] = useState(true);
const college=sessionStorage.getItem("user_id")
    const getNewCourseAmount = () => {
        const url = `${config.url.FAC_URL}getInputDetails/new/${college}`;
        
        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.scode === "01" && res.data.new?.length > 0) {
                    // Fetch all course details with their names
                    const fetchPromises = res.data.new.map(async (item) => {
                        let courseGroupName = item.course_group_code;
                        let courseTypeName = item.course_type;
                        let courseName = item.course_id;
                        
                        try {
                            // Fetch course group name
                            const groupUrl = `${config.url.FAC_URL}getCourseGroupList`;
                            const groupRes = await CommonAxiosGet(groupUrl);
                            if (groupRes?.data?.scode === "01") {
                                const groupFound = groupRes.data.getCourseGroupList?.find(
                                    g => g.course_group_code == item.course_group_code
                                );
                                if (groupFound) courseGroupName = groupFound.course_group_desc;
                            }

                            // Fetch course category name (Stream)
                            const categoryUrl = `${config.url.FAC_URL}getCourseCategoryList/${item.course_group_code}`;
                            const categoryRes = await CommonAxiosGet(categoryUrl);
                            if (categoryRes?.data?.scode === "01") {
                                const categoryFound = categoryRes.data.getCourseCategoryList?.find(
                                    c => c.course_cat_id == item.course_type
                                );
                                if (categoryFound) courseTypeName = categoryFound.course_cat_name;
                            }

                            // Fetch course name (Single Major)
                            const courseUrl = `${config.url.FAC_URL}getSpecilization/${item.course_type}`;
                            const courseRes = await CommonAxiosGet(courseUrl);
                            if (courseRes?.data?.scode === "01") {
                                const found = courseRes.data.Specilization?.find(
                                    c => c.course_id == item.course_id
                                );
                                if (found) courseName = found.course_name;
                            }
                        } catch (err) {
                            console.error("Error fetching details:", err);
                        }
                        
                        return {
                            courseGroupName: courseGroupName,
                            courseTypeName: courseTypeName,
                            courseName: courseName,
                            amount: parseFloat(item.area_fee) || 0
                        };
                    });
                    
                    Promise.all(fetchPromises).then(data => {
                        setProgrammesData(data);
                        setLoading(false);
                    });
                } else {
                    setProgrammesData([]);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
                setProgrammesData([]);
                setLoading(false);
            });
    };

    useEffect(() => {
        getNewCourseAmount();
    }, []);

    const totalAmount = programmesData.reduce((sum, programme) => sum + programme.amount, 0);

    if (loading) {
        return <div className="text-center p-4">Loading...</div>;
    }

    return (
        <Card className="shadow-sm">
             <FinalcialResources data={programmesData} type="New Program"/>
            <Card.Header className="bg-white fw-bold text-primary text-center">
                New Course Approval Fees
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                        <thead className="table-success">
                            <tr>
                                <th className="text-center" width="60px">S.No</th>
                                <th>Type (Group)</th>
                                <th>Name of the Stream</th>
                                <th>Name of the Single Major</th>
                                <th className="text-end">Approval Fee (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {programmesData.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted">
                                        No courses added
                                    </td>
                                </tr>
                            ) : (
                                programmesData.map((programme, idx) => (
                                    <tr key={idx}>
                                        <td className="text-center fw-bold">{idx + 1}</td>
                                        <td>{programme.courseGroupName}</td>
                                        <td>{programme.courseTypeName}</td>
                                        <td><strong>{programme.courseName}</strong></td>
                                        <td className="text-end fw-bold">
                                            ₹ {programme.amount.toLocaleString('en-IN')}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        <tfoot className="table-light fw-bold">
                            <tr>
                                <td colSpan="4" className="text-end">Total:</td>
                                <td className="text-end text-primary">
                                    ₹ {totalAmount.toLocaleString('en-IN')}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Card.Body>
           
        </Card>
    );
}